import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthRoutingModule } from './auth-routing.module';
import { LoginComponent } from './login/login.component';
import { SharedModule } from '../shared/shared.module';
import { OtpVerificationComponent } from './otp-verification/otp-verification.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { FlashScreenComponent } from './flash-screen/flash-screen.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { DelectAcountDummyComponent } from './delect-acount-dummy/delect-acount-dummy.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ContactUsComponent } from '../contact-us/contact-us.component';


@NgModule({
  declarations: [    
    LoginComponent,
    OtpVerificationComponent,
    FlashScreenComponent,
    ResetPasswordComponent,
    SignUpComponent,
    PrivacyPolicyComponent,
    DelectAcountDummyComponent,
    ChangePasswordComponent
  ],
  imports: [
    CommonModule,
    AuthRoutingModule,
    SharedModule,
    ReactiveFormsModule,
    HttpClientModule,
    FormsModule,
    AuthRoutingModule,
  
  ]
})
export class AuthModule { }
